/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ServicedeskKnowledgeHubDraftsType from '@jira/spa-apps__servicedesk-knowledge-hub-drafts/src/index.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskKnowledgeHubDrafts: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ServicedeskKnowledgeHubDraftsType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-servicedesk-knowledge-hub-drafts", jiraSpaEntry: "async-servicedesk-knowledge-hub-drafts" */ '@jira/spa-apps__servicedesk-knowledge-hub-drafts/src/index.tsx'
			),
		),
	);

const AsyncServicedeskKnowledgeHubDrafts = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskKnowledgeHubDrafts}
		pageId="spa-apps/servicedesk/knowledge-hub/drafts"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskKnowledgeHubDrafts;
